import { VehicleDetailModel } from "@app/models/VehicleDetailModel";

export class TicketRequestSearchView{
    profile=new Customer();
    TxnList=new Array<CustomerTransSummary>();
}
export class Customer {
    CardStatusId:number
    CustomerId: number;
    CompanyName: string;
    PanNumber: string;
    TINNo: string;
    Name: string;
    FirstName: string;
    LastName: string;
    FullName: string;
    NoOfCardsRequired: number;
    NoOfCards: number;
    UserName: string;
    Password: string;
    ConfirmPassword: string;
    DefaultPIN: string;
    VerifyOTP: number;
    VerifyOTPNewMobile: number;
    PIN: number;
    PrimaryEmailAddress: string;
    CustomerCode: string;
    Address = new AddressInfoModel();
    ContactDetails = new ContactInfoModel();
    Email: string;
    MobileNumber: string;
    MobileNo: string;
    CreditLimit: string;
    StatusTypeId: number;
    LedgerTypeId: number;
    StatementCycleId:number;
    DocumentListForRegistration=new FileUpload();
    CustomerType: string;
    CustomerTypeId:number;
    isSms: boolean;
    SubCategoryTypeId:number;
    CardNumber:string;
    FleetCardMappingVM=new Array<VehicleDetailModel>();
    CardBalance:number
    CardId:number
    CategoryTypeId:number
}

export class AddressInfoModel {
    Address1: string;
    Country: string;
    State: string;
    City: string;
    Location: string;
    PinCode: number;
    CountryId?: number = 0;
    StateId?: number = 0;
    CityId: number = 0;
}

export class ContactInfoModel {
    IsEmail : boolean;
    IsSMS  : boolean;
    EmailAddress: string;
    MobileNumber: string;
    PhoneNumber: string;
    ContactPersonLastName: string;
    ContactPersonFirstName: string;
}

export class FileUpload {
    EntityId:number;
    DocumentTypeId:number;
    DocumentType:string;
    DocumentList:Array<DocumentList>=new Array<DocumentList>();
    IsRejected: boolean;
    Reason: string;
}
export class DocumentList{
    EntityId:number;
    DocumentType:string;
    DocumentTypeId:number;
    DocumentName:string;
    IsRejected: boolean;
    Reason: string;
}
export class CustomerTrans{
    CustomerTransSummary=new Array<CustomerTransSummary>();
    Count:number;
}
export class CustomerTransSummary{
    TransId:number;
    TransNumber:string;
    CardNumber:string;
    TxnDate:string;
    TransactionDate:string;
    TxnAmount:number;
    Narration:string;
    Status:number;
    MerchantName:string;
    OutletName:string;
    CardBalance:number;
    BatchId:number;
    ROC:number;
    CustomerId:number;
    TerminalNumber:string;
    TxnTypeId:number;
    TxnType:string;
    TxnStatus:string;
    BatchNumber:number;
    SkipCount:number;
    PageSize:number;
    Quantity:number;
}
export class CustomerCard{
    CardNumber:string;
    StatusTypeId:number;
    ActivationDates:Date;
    CardBalance:number;
    CardId:number;
    CustomerCode:string;
    MobileNumber:string;
    Otp:number;
    CardIdToTransferBalance:number;
    CardNumberToTransferBalance:string='0';
    IpAddress:string;
}


// WEBPACK FOOTER //
// ./src/app/models/customer-registration/CustomerModel.ts